import { Component, Input } from '@angular/core';
import {
  SupportFaqAnswerBlock,
  SupportFaqInlinePart,
} from '../support-faq.content';

@Component({
  standalone: false,
  selector: 'app-support-faq-answer',
  templateUrl: './support-faq-answer.component.html',
  styleUrls: ['./support-faq-answer.component.scss'],
})
export class SupportFaqAnswerComponent {
  @Input({ required: true }) blocks: SupportFaqAnswerBlock[] = [];

  trackBlock(_index: number, block: SupportFaqAnswerBlock): string {
    return `${block.type}-${_index}`;
  }

  trackPart(_index: number, part: SupportFaqInlinePart): string {
    if (part.type === 'link') {
      return `${part.type}-${_index}-${part.label}`;
    }

    return `${part.type}-${_index}-${part.value}`;
  }

  isExternalLink(href: string): boolean {
    return href.startsWith('http');
  }
}
